"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CardQuestionContainer;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Card = require("@mui/material/Card");

var _Card2 = _interopRequireDefault(_Card);

var _CardHeader = require("@mui/material/CardHeader");

var _CardHeader2 = _interopRequireDefault(_CardHeader);

var _CardContent = require("@mui/material/CardContent");

var _CardContent2 = _interopRequireDefault(_CardContent);

var _CheckCircle = require("@mui/icons-material/CheckCircle");

var _CheckCircle2 = _interopRequireDefault(_CheckCircle);

var _colors = require("@mui/material/colors");

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _QuestionText = require("../QuestionText");

var _QuestionText2 = _interopRequireDefault(_QuestionText);

var _QuestionContext = require("../QuestionContext");

var _QuestionContext2 = _interopRequireDefault(_QuestionContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const AnimatedIcon = _styledComponents2.default.div`
  transition: 300ms transform, 300ms opacity;
`;
const FadedTitle = _styledComponents2.default.span`
  opacity: 0.6;
`;
const ErrorText = _styledComponents2.default.div`
  color: ${_colors.red[500]};
`;

function CardQuestionContainer({
  question,
  answered,
  children,
  error: valueError,
  fadedTitle
}) {
  return _react2.default.createElement(_QuestionContext2.default.Consumer, null, ({
    error: contextError,
    noCheckmarks
  } = {}) => {
    const error = valueError ? _react2.default.createElement("div", null, valueError, _react2.default.createElement("br", null), contextError) : contextError;
    return _react2.default.createElement(_Card2.default, {
      id: question.name,
      style: {
        position: "relative",
        margin: 20
      }
    }, _react2.default.createElement(_CardHeader2.default, {
      style: {
        paddingRight: 40
      },
      title: _react2.default.createElement("span", null, question.title || question.name, fadedTitle && _react2.default.createElement(FadedTitle, null, " ", fadedTitle)),
      subheader: _react2.default.createElement("span", null, question.description, error && _react2.default.createElement(ErrorText, null, error))
    }), _react2.default.createElement(_CardContent2.default, {
      style: {
        overflowX: "hidden"
      }
    }, children), !answered && question.isRequired && _react2.default.createElement("div", {
      style: {
        position: "absolute",
        right: 26,
        top: 14
      }
    }, _react2.default.createElement(_QuestionText2.default, {
      style: {
        fontSize: 36,
        fontWeight: 800,
        color: _colors.grey[600]
      }
    }, "*")), !noCheckmarks && _react2.default.createElement("div", {
      style: {
        position: "absolute",
        right: 16,
        top: 16
      }
    }, _react2.default.createElement(AnimatedIcon, {
      style: !answered ? {
        transform: "rotate(-45deg) scale(0.8)",
        opacity: 0
      } : {
        transform: "rotate(8deg)",
        opacity: 1
      }
    }, _react2.default.createElement(_CheckCircle2.default, {
      style: {
        width: 36,
        height: 36,
        color: _colors.green[600]
      }
    }))));
  });
}